export default "__VITE_ASSET__BKKOvasZ__"